/// <reference types="vite/client" />
// Kataloglar `import.meta.glob` kullanır: Vite tabanlı derleyici (widget, panel, site) ya da Vitest ister.
import { defineCatalog } from '../catalog.ts';
import type { VisitorLocale } from '../locales.ts';
import type source from '../../messages/launcher/en.json';

/** Kapalı balon: yükleyici tek dosya (IIFE) olduğundan dosyalar pakete gömülür; birkaç kısa metin. */
export type LauncherMessages = typeof source;

export const launcherCatalog = defineCatalog<LauncherMessages, VisitorLocale>(
  'launcher',
  import.meta.glob('../../messages/launcher/*.json', { eager: true, import: 'default' }),
);
